import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class AWSService {
  constructor(private http: HttpClient) {}

  uploadImage(signed_request: string, file: File) {
    return this.http.put(signed_request, file, {
      headers: {
        skipIntercept: "true",
        "x-amz-acl": "public-read",
        "Content-Type": file.type,
      },
    });
  }
}
